export default {
    name: "detail",
    data:function () {
        return{
            tab:"info",
            addressList:[],
            value1:0,
            showEv:false,
            info:{},
            cityId:310100,
            ListCustomerJob:[],
            SystemScore:{},
            currentItem:{},
            Remarks:''
        }
    },
    methods:{
        init:function(){
            var _this=this;
            this.$get("/customerservicemanager/mycustomerdetail",{
                customerNumber:this.$route.params.id
            },function (result) {
                if(result.Success){
                    result.Result.area={
                        Shortname:result.Result.Area
                    };
                    _this.info=result.Result;
                    _this.ListCustomerJob=result.Result.ListCustomerJob;
                    _this.SystemScore=result.Result.SystemScore;
                }else{
                    _this.$toast(result.Message);
                }
            })
        },
        getArea:function(){
            var _this=this;
            this.$get("/query/listarea",{
                cityid:this.cityId
            },function (result) {
                _this.addressList=result;
            });
        },
        checkAddress:function (item) {
            console.log(item);
        },
        saveCustomerInfo: function() {
          var _this=this;
          this.$post("/customerservicemanager/savecustomer", this.info,function (result) {
            if(result.Success){
              _this.$toast("保存成功");
            }else{
              _this.$toast(result.Message);
            }
          })
        },
       doEvaluate:function () {
            var _this=this;
            this.$post("/customerservicemanager/evaluate",{
                "JobId": this.currentItem.JobId,
                "Remarks": this.Remarks,
                "Score": this.value1
            },function (result) {
                _this.showEv=false;
                if(result.Success){
                    _this.$toast("评价成功");
                }else{
                    _this.$toast(result.Message);
                }
            });
         }
    },
    watch: {
      '$route': function (to, from) {
        if (to && to.name === 'clientDetail'){
          this.init();
        }
      }
    },
    mounted:function(){
        this.init();
        this.getArea();
    },
    computed:{
        size:function () {
            return document.documentElement.clientWidth *1.8/ 7.5
        }
    }
}



// WEBPACK FOOTER //
// ./src/ally/page/myClient/detail.js